import React from 'react';
import IconArrowDown from 'src/assets/images/icons/arrow-down.svg';
import { useColumnHeaderContext } from '../hooks/useColumnHeaderContext';

interface ColumnHeaderButtonProps {
  customHeader?: React.ReactNode;
  icon?: React.ReactNode;
}

export const ColumnHeaderButton: React.FC<ColumnHeaderButtonProps> = ({ customHeader, icon }) => {
  const { popover, items, column } = useColumnHeaderContext();

  return (
    <div className='flex items-center w-full gap-8' style={{ height: '100%', minHeight: 24, display: 'flex', alignItems: 'center' }}>
      {/* Icon */}
      {icon && <div className='flex items-center justify-center w-16 h-16 flex-shrink-0'>{icon}</div>}

      {/* Header Text */}
      {!customHeader && column.columnDef.header && <span className='text-left flex-1 mr-5 whitespace-nowrap'>{column.columnDef.header}</span>}
      {customHeader && <div>{customHeader}</div>}

      {/* Counter Badge & Dropdown */}
      <div className='ml-auto flex items-center'>
        {items.count !== undefined && items.count > 0 && (
          <div className='ml-12 rounded-full px-6 border border-primary text-primary text-[10px] leading-[18px] font-bold'>{items.count}</div>
        )}

        {/* Dropdown Arrow */}
        <button type='button' onClick={popover.onOpen} className='w-16 ml-8'>
          <img src={IconArrowDown} alt='Sort' className='w-full' />
        </button>
      </div>
    </div>
  );
};
